import { useQuery, UseQueryOptions } from 'react-query';

import { LenderMatchDrillIn } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useMatchingTrancheLendersQuery(
	guid: string | undefined,
	mode: number | undefined,
	tier1: number | undefined,
	structure: number | null,
	finderFee: boolean | undefined,
	filterType: number | undefined,
	matchMode: number | undefined,
	options?:
		| Omit<UseQueryOptions<LenderMatchDrillIn[], unknown, LenderMatchDrillIn[]>, 'queryKey' | 'queryFn'>
		| undefined
) {
	const api = useApi();
	const url = CerebroApiEndpoints.Matching.Lenders(guid, mode, tier1, finderFee, structure, filterType, matchMode);

	return useQuery(
		QueryKeys.Matching.Lenders(guid, mode, tier1, finderFee, structure, filterType, matchMode),
		() => AxiosUtils.getResponseData<LenderMatchDrillIn[]>(api.get(url)),
		options
	);
}
